const otherLayoutEnvs = [
  'REACT_APP_WEBAPP_NAME',
  'REACT_APP_WEBAPP_LONG_DESCRIPTION',
  'REACT_APP_BASE_URL',
  'REACT_APP_STRING_APPDOWNLOAD_CTA_DESCRIPTION',
  'REACT_APP_APPDOWNLOAD_PRIMARY_LINK',
  'REACT_APP_APPDOWNLOAD_SECONDARY_LINK',
  'REACT_APP_WEBSITE_URL',
  'REACT_APP_LOG_PASSWORD',
  'REACT_APP_SPLUNK_URL',
  'REACT_APP_SPLUNK_PROPERTY_ID',
  'REACT_APP_GOOGLE_ANALYTICS_4_0_ID',
  'REACT_APP_FACEBOOK_PIXEL_0',
  'REACT_APP_ONE_TRUST_DOMAIN',
]

export default otherLayoutEnvs
